import React, { useMemo } from 'react';
import {
  PricingOptionsWrapper,
  ExpiryDetails,
  PaymentsTileContainer,
  ExpiryTextWrapper,
  OfferDescriptions,
} from './PricingOptions.styles';
import {
  CopyTwo,
  TextCTA,
  StyledText,
  TextAlign,
  FlexContainer,
} from '../../../Common/Common.styles';
import { COLORS } from '../../../../styles/variables';
import PaymentsOptions from './PaymentsOptions';
import { PromotionType } from '../../../../types/offers';

type PricingOptionsProps = {
  offer: PromotionType;
  offerType: string;
  showOfferDetails: (e: any) => void;
};

const PricingOptions: React.FC<PricingOptionsProps> = ({ offer, offerType, showOfferDetails }) => {
  const { programShortDescription } = offer;

  const renderExpiry = useMemo(() => {
    return (
      <ExpiryDetails marginTop={offerType === 'finance' ? '20' : undefined}>
        <ExpiryTextWrapper>
          <StyledText
            data-testid="model-offer-valid-date"
            variant={{
              type: 'copy',
              order: '2',
              style: 'normal',
            }}
            color={COLORS.grey60}
          >
            Offer end {offer.programToDate}
          </StyledText>
        </ExpiryTextWrapper>
        <TextCTA
          data-testid="model-cta-offer-details"
          onClick={showOfferDetails}
          color={COLORS.grey60}
          size="small"
          isBold
        >
          *View offer details
        </TextCTA>
      </ExpiryDetails>
    );
  }, [offer.programToDate, offerType, showOfferDetails]);

  const renderPaymentAndLegal = useMemo(() => {
    return (
      <>
        <PaymentsTileContainer>
          <PaymentsOptions offer={offer} offerType={offerType} />
        </PaymentsTileContainer>
        <OfferDescriptions>
          <TextAlign>
            <CopyTwo>{programShortDescription}</CopyTwo>
          </TextAlign>
        </OfferDescriptions>
      </>
    );
  }, [offer, offerType, programShortDescription]);

  return (
    <PricingOptionsWrapper>
      {offerType === 'finance' ? (
        <FlexContainer direction="column" justifyContent="space-between" gap={12}>
          {renderPaymentAndLegal}
        </FlexContainer>
      ) : (
        renderPaymentAndLegal
      )}
      {renderExpiry}
    </PricingOptionsWrapper>
  );
};

export default PricingOptions;
